"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("styled-components")).default.section`
  position: relative;
  margin: 97px 0 95px;

  .inner {
    max-width: ${({theme:e})=>e.widths.small};
    margin: 0 auto;
    padding: 0 ${({theme:e})=>e.spacing.large};
    display: grid;
    grid-row-gap: 50px;

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
      max-width: ${({theme:e})=>e.widths.large};
      padding: 0 ${({theme:e})=>e.spacing.large};
    }
  }

  nav {
    button {
      background: transparent;
      border-radius: 0;
      box-shadow: ${({theme:e})=>e.shadows.low};
      padding: 14px;
      border: solid 1px ${({theme:e})=>e.colors.grey[300]};
      color: ${({theme:e})=>e.colors.grey[0]};
      font-weight: 600;
      cursor: pointer;
      transition: all 0.4s ease-in-out;
      line-height: 1em;

      &.active {
        border: solid 1px ${({theme:e})=>e.colors.primary.default};
        color: ${({theme:e})=>e.colors.primary.default};
        cursor: initial;
      }
    }
  }

  picture {
    width: 100%;
    height: auto;

    img {
      width: 100%;
      height: auto;
    }
  }

  footer {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        box-sizing: border-box;
        max-width: ${({theme:e})=>e.widths.small};
        padding: 0 ${({theme:e})=>e.spacing.medium} 46px;
        z-index: 10;

        @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
            max-width: 428px;
        }
    }
`;module.exports=t;
//# sourceMappingURL=styled.js.map
